import { authFetch } from './authFetch';
import { API_BASE } from './version';

export interface AppStatusResult {
  installed: boolean;
  scope?: 'org' | 'repo';
  installUrl?: string;
}

export async function checkGitHubAppStatus(org: string, repo?: string): Promise<AppStatusResult> {
  const qs = repo
    ? `?org=${encodeURIComponent(org)}&repo=${encodeURIComponent(repo)}`
    : `?org=${encodeURIComponent(org)}`;
  const r = await authFetch(`${API_BASE}/github/app-status${qs}`);
  if (!r.ok) throw new Error(`GitHub status check failed: ${r.status}`);
  return ((await r.json()) as { data: AppStatusResult }).data;
}
